import React from "react";

function Twitter(props) {
    return (
      <svg
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0.66 0.75 23.11 18.94"
        {...props}
      >
        <path
          d="M23.594 4.638a.5.5 0 00-.2-.87l-.79-.19a.49.49 0 01-.33-.28.5.5 0 010-.43l.45-.89a.5.5 0 00-.59-.7l-2 .56a.48.48 0 01-.43-.09 5 5 0 00-8 4v.36a.25.25 0 01-.22.25c-2.81.33-5.5-1.1-8.4-4.44a.5.5 0 00-.51-.16.49.49 0 00-.3.44 7.52 7.52 0 00.46 4.92.27.27 0 010 .26.24.24 0 01-.25.1l-1.13-.22a.52.52 0 00-.44.15.51.51 0 00-.13.44 5.15 5.15 0 002.37 3.78.25.25 0 01.12.23.24.24 0 01-.15.22l-.54.21a.53.53 0 00-.28.29.51.51 0 000 .4 4.36 4.36 0 003.2 2.48.27.27 0 01.19.22.26.26 0 01-.15.26 11 11 0 01-4.27.82.51.51 0 10-.2 1 19.92 19.92 0 008.14 1.93 12.6 12.6 0 007-2 12.482 12.482 0 005.56-10.43v-.87a.49.49 0 01.18-.38l1.64-1.37z"
          fill="#0D3727"
        />
      </svg>
    )
  }
  
const SocialItem = (props) => {
    return(
        <Twitter className='h-[19px] transition-transform duration-300 hover:scale-105'/>
    )
}


const JoinTheClub = () => {
    return(
        <ul className="flex flex-row items-center justify-center tk-fatfrank lg:text-[16px] button-padding bg-[#DBFF00] text-[#0D3727] lg:space-x-[24px] w-fit">
                <li className="text">
                    Join the club
                </li>
                <SocialItem/>
                <SocialItem/>
                <SocialItem/>

        </ul>
    )
}

export default JoinTheClub